/**
 * Load an image URL as a File for multipart upload to the postcard middleware.
 * Drupal public files are fetched via same-origin path to avoid CORS.
 */
export async function fetchImageAsFile(url: string): Promise<File> {
  const parsed = new URL(url, window.location.origin)
  const fetchUrl = parsed.pathname.includes('/sites/default/files/')
    ? `${parsed.pathname}${parsed.search}`
    : url

  const response = await fetch(fetchUrl, { cache: 'no-store' })
  if (!response.ok) {
    throw new Error(`Failed to fetch image: ${response.status}`)
  }

  const blob = await response.blob()
  const filename =
    parsed.pathname.split('/').pop()?.split('?')[0] || 'image.jpg'
  const type = ['image/jpeg', 'image/png'].includes(blob.type)
    ? blob.type
    : 'image/jpeg'

  return new File([blob], filename, { type })
}
